import { forwardRef, type SVGProps } from 'react';

export const Send = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ref={ref} {...props}>
    <g fill="currentColor">
      <path
        d="M23.82 1.116a.5.5 0 0 0-.512-.078l-23 9.5a.5.5 0 0 0 .01.927l6.332 2.459a.5.5 0 0 0 .468-.056l8.4-5.974a.5.5 0 0 1 .637.768l-7 6.745a.5.5 0 0 0-.153.36V22.5a.5.5 0 0 0 .931.252l3.167-5.425a.251.251 0 0 1 .337-.093l5.826 3.2a.5.5 0 0 0 .73-.332l4-18.5a.508.508 0 0 0-.173-.486z"
        fill="currentColor"
      />
    </g>
  </svg>
));
